import { get } from 'lodash-es';
import { Trans, useTranslation as _useTranslation } from 'react-i18next';

const cachedMap = new Map();

/**
 * Create a custom hook for optimizing later
 */
export const useTranslation = () => {
  const { t: _t } = _useTranslation('translation', { i18n: get(window, 'BoostSDI18next') });

  return {
    t: ((...params: Parameters<typeof _t>): string => {
      if (params.length < 2) {
        const cachedValue = cachedMap.get(params[0]);

        if (cachedValue) return cachedValue;
        const value = _t(params[0]);
        cachedMap.set(params[0], value);

        return value;
      }

      return _t(...params);
    }) as typeof _t,
  };
};

export { Trans };

export default useTranslation;
